/*=========================================================================================
  File Name: getters.js
  Description: Vuex Store - getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// added so later we can keep breakpoint in sync automatically using this config file
// import tailwindConfig from "../../tailwind.config.js"

String.prototype.CIAI = function(){
  return this.toLowerCase()
    .replace(/[áàãâä]/gi,"a")
    .replace(/[éè¨ê]/gi,"e")
    .replace(/[íìïî]/gi,"i")
    .replace(/[óòöôõ]/gi,"o")
    .replace(/[úùüû]/gi, "u")
    .replace(/[ç]/gi, "c")
    .replace(/[ñ]/gi, "n")
    .replace(/[^a-zA-Z0-9]/g," ");
}

const getters = {

	// COMPONENT
		// vx-autosuggest
	// starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
  windowBreakPoint: state => {

    // This should be same as tailwind. So, it stays in sync with tailwind utility classes
    if (state.windowWidth >= 1600) return "xxl";
    else if (state.windowWidth >= 1400) return "1xl";
    else if (state.windowWidth >= 1200) return "xl";
    else if (state.windowWidth >= 992) return "lg";
    else if (state.windowWidth >= 768) return "md";
    else if (state.windowWidth >= 576) return "sm";
    else return "xs";
  },

  scrollbarTag: state => {
    return state.is_touch_device ? 'div' : 'VuePerfectScrollbar'
  },

  getParameter: state => paramSearch => {
    const result = state.parameters.filter((parameter) => parameter.id === paramSearch)
    return result.length ? result.pop() : []
  },

  stores: state => {
    var list = [];
    if (state.stores) {
      if (state.stores.list) {
        list = state.stores.list.filter((category) => category.status == 'ACT');
      }
    }
    return list;
  },
  getStore: state => paramSearch => {
    const result = state.stores.list.filter((store) => store.code === paramSearch);
    return result.length ? result.pop() : [];
  },

  categories: state => {
    var list = [];
    if (state.categories) {
      if (state.categories.list) {
        list = state.categories.list.filter((category) => category.status == 'ACT').sort(function (a, b) {
          var ret = 1;
          if (a.sequence < b.sequence) {
            ret = -1;
          }
          return ret;
        });
      }
    }
    return list;
  },
  getCategory: state => paramSearch => {
    const result = state.categories.list.filter((category) => category.id === paramSearch);
    return result.length ? result.pop() : [];
  },

  showcaseProducts: state => {
    var list = [];
    if (state.showcaseProducts) {
      if (state.showcaseProducts.list) {
        list = state.showcaseProducts.list.filter((showcase) => showcase.status == 'ACT').sort(function (a, b) {
          var ret = 1;
          if (a.sequence < b.sequence) {
            ret = -1;
          }
          return ret;
        });
      }
    }
    return list;
  },

  priceRanges: state => {
    var list = [];
    if (state.priceRanges) {
      if (state.priceRanges.list) {
        list = state.priceRanges.list.filter((priceRange) => priceRange.status == 'ACT').sort(function (a, b) {
          var ret = 1;
          if (a.sequence < b.sequence) {
            ret = -1;
          }
          return ret;
        });
      }
    }
    return list;
  },

  products: state => {
    var list = [];
    if (state.products) {
      if (state.products.list) {
        list = state.products.list.filter(item => item.status == 'ACT').sort(function (a, b) {
          let ret = 1;
          if (a.categories < b.categories) {
            ret = -1;
          }
          return ret;
        });
      }
    }
    return list;
  },
  getProduct: state => paramSearch => {
    const result = state.products.list.filter((product) => product.id === parseInt(paramSearch));
    return result.length ? result.pop() : [];
  },

  refinedProductsListBAK: state => {
    var list = [];
    if (state.products) {
      if (state.products.list) {
        list = state.products.list.filter(item => (item.status == 'ACT'));
          if (state.productSearch == '') {
            if (state.priceRange) {
              list = list.filter(item => item.price >= state.priceRange.min && item.price <= state.priceRange.max);
            }
            if (state.selectedCategory) {
              list = list.filter(item => item.categories && item.categories.split(',').includes(state.selectedCategory.id));
            }
          } else {
            return list.filter(item => (item.name.CIAI().indexOf(state.productSearch.CIAI()) !== -1 || item.code.indexOf(state.productSearch) !== -1));
          }
      }
    }
    return list;
  },

  refinedProductsList: (state, getters) => {
    var list = [];
    if (getters.products) {
        list = getters.products.filter(item => (item.status == 'ACT'));
        if (state.productSearch == '') {
          if (state.priceRange) {
            list = list.filter(item => item.price >= state.priceRange.min && item.price <= state.priceRange.max);
          }
          if (state.selectedCategory) {
            list = list.filter(item => item.categories && item.categories.split(',').includes(state.selectedCategory.id));
          }
        } else {
          return list.filter(item => (item.name.CIAI().indexOf(state.productSearch.CIAI()) !== -1 || item.code.indexOf(state.productSearch) !== -1 || item.description.CIAI().indexOf(state.productSearch.CIAI()) !== -1));
        }
    }
    return list;
  }
}

export default getters
